// FILE: src/store/Slices/DashboardSlice.js (FULLY UPDATED)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosServices from '../../services/axios';

export const fetchOnboardingStatus = createAsyncThunk(
  'dashboard/fetchOnboardingStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosServices.get('/user/onboarding-status');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch onboarding status');
    }
  }
);

// --- START: NEW THUNK FOR MANUAL COMPLETION ---
export const markChecklistItemComplete = createAsyncThunk(
  'dashboard/markChecklistItemComplete',
  async (taskKey, { dispatch, rejectWithValue }) => {
    try {
      await axiosServices.post('/user/mark-checklist-complete', { taskKey });
      // After successfully marking it complete, re-fetch the entire status to ensure UI is in sync.
      dispatch(fetchOnboardingStatus());
      return { taskKey }; // Return the key on success
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || `Failed to mark ${taskKey} as complete.`);
    }
  }
);
// --- END: NEW THUNK ---

// --- START: UPDATED INITIAL STATE ---
const initialState = {
  checklist: null, // Changed from an array to null to hold the group object
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};
// --- END: UPDATED INITIAL STATE ---

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingStatus.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOnboardingStatus.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.checklist = action.payload; // Payload is now the group object
      })
      .addCase(fetchOnboardingStatus.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // --- START: NEW REDUCER FOR MANUAL COMPLETION ---
      // Although we re-fetch, this provides an optimistic update if needed,
      // and handles loading/error states for the specific action.
      .addCase(markChecklistItemComplete.pending, (state) => {
        // Optionally handle a specific loading state for this action
      })
      .addCase(markChecklistItemComplete.rejected, (state, action) => {
        // Optionally handle specific errors for this action
        console.error("Failed to mark checklist item:", action.payload);
      });
      // --- END: NEW REDUCER ---
  },
});

export default dashboardSlice.reducer;